import React from 'react'
import { Table as ReactTable } from 'reactstrap';


export const ActivationsTable = ({ data, loading }) => {

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    };

    return (
        <ReactTable striped>
            <thead>
                <tr>
                    <th>Serial Number</th>
                    <th>MAC Address</th>
                    <th>Creation Date</th>
                    <th>Activation Date</th>
                    <th>Deactivation Date</th>
                    <th>Activation Count</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => (
                    <tr key={index}>
                        <td>{item.serialNumber}</td>
                        <td>{item.macAddress}</td>
                        <td>{formatDate(item.createdDate)}</td>
                        <td>{formatDate(item.activationDate)}</td>
                        <td>{formatDate(item.deactivationDate)}</td>
                        <td>{item.activationCount}</td>
                    </tr>
                ))}
            </tbody>
        </ReactTable>
    )
}